/**
 * @generated SignedSource<<aad49c07c70fb42dd6ba8f28b5ac8856>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProgramType = "ACCESSORIES_3_D_ACCREDITATION" | "A_A_3_D_ACCREDITATION" | "NONE" | "SOFT_HOME_3_D_ACCREDITATION" | "_3_D_STYLING" | "%future added value";
export type SoftwareType = "BROWZWEAR" | "CLO" | "NONE" | "OPTITEX" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GroupTemplateModulesTablePaginationFragment_modules$data = {
  readonly modules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly flow: {
          readonly durationInSeconds: number | null | undefined;
          readonly flowReviewers: {
            readonly nodes: ReadonlyArray<{
              readonly reviewer: {
                readonly fullName: string;
              } | null | undefined;
            }>;
          };
          readonly name: string;
          readonly rowId: UUID;
          readonly updatedAt: Date | null | undefined;
        } | null | undefined;
        readonly programType: ProgramType | null | undefined;
        readonly softwareType: SoftwareType | null | undefined;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "GroupTemplateModulesTablePaginationFragment_modules";
};
export type GroupTemplateModulesTablePaginationFragment_modules$key = {
  readonly " $data"?: GroupTemplateModulesTablePaginationFragment_modules$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTemplateModulesTablePaginationFragment_modules">;
};

import GroupTemplateModulesTablePaginationQuery_Refetchable_graphql from './GroupTemplateModulesTablePaginationQuery_Refetchable.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "modules"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "moduleFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "modulesOrderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": GroupTemplateModulesTablePaginationQuery_Refetchable_graphql
    }
  },
  "name": "GroupTemplateModulesTablePaginationFragment_modules",
  "selections": [
    {
      "alias": "modules",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "moduleFilter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "modulesOrderBy"
        }
      ],
      "concreteType": "ModulesConnection",
      "kind": "LinkedField",
      "name": "__GroupTemplateModulesTable_modules_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ModulesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Module",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "programType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "softwareType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Flow",
                  "kind": "LinkedField",
                  "name": "flow",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rowId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "updatedAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationInSeconds",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FlowReviewersConnection",
                      "kind": "LinkedField",
                      "name": "flowReviewers",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FlowReviewer",
                          "kind": "LinkedField",
                          "name": "nodes",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "GwtUser",
                              "kind": "LinkedField",
                              "name": "reviewer",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "fullName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8a5e8274fa412aadf16b88b00d039df5";

export default node;
